import React from "react";
import { useDropzone } from "react-dropzone";
import PropsTypes from "prop-types";
import {
  Box,
  FormHelperText,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";

export const FileDropzoneComponent = ({
  handleDropzone,
  fileName,
  height = "121px",
  width = "100%",
}) => {
  const [message, setMessage] = React.useState("");
  const theme = useTheme();

  const onDrop = React.useCallback((acceptedFiles) => {
    acceptedFiles.length > 0 && handleDropzone(acceptedFiles[0]);
  }, []);

  const onDropRejected = (data) => {
    if (Array.isArray(data) && data.length > 0 && data[0]?.errors[0]?.message)
      setMessage(data[0].errors[0]?.message);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      "file/types": [".xlsx", ".xls"],
    },
    maxFiles: 1,
    onDropRejected,
  });

  React.useEffect(() => {
    if (message.trim().length > 0) setMessage("");
  }, []);

  return (
    <Stack>
      <Box
        sx={{
          cursor: "pointer",
          overflow: "hidden",
          borderRadius: "8px",
          backgroundColor: "rgba(0, 0, 0, 0.03)",
          border: "1px dashed rgba(200, 200, 200, 1)",
          width,
          height,
        }}
      >
        <Stack
          component="div"
          {...getRootProps({ className: "dropzone" })}
          sx={{
            position: "relative",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px",
          }}
        >
          <Box component="input" {...getInputProps()} />
          <Box
            elevation={0}
            sx={{
              border: "1px solid #E0E0E0",
              borderRadius: "8px",
              padding: "16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              minHeight: "50px",
              bgcolor: "#FFFFFF",
              width: "100%",
              overflow: "hidden",
            }}
          >
            <img
              src="/icons/ic_files.svg"
              style={{
                marginRight: "4px",
              }}
              alt="file"
            />
            <Typography
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              width="calc(100% - 32px)"
              overflow="hidden"
            >
              {fileName}
            </Typography>
          </Box>
          <Stack
            sx={{
              borderRadius: "8px",
              alignItems: "center",
              justifyContent: "center",
            }}
            component="label"
          >
            <Stack
              direction="row"
              gap={1}
              alignContent="center"
              mt={2}
              alignSelf="center"
            >
              <Typography fontWeight={400} fontSize="12px" color="#808080">
                Replace,Drag & Drop Or
              </Typography>
              <Typography
                fontWeight={400}
                fontSize="12px"
                sx={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  color: "info.main",
                }}
              >
                Upload
              </Typography>
              <Typography fontWeight={400} fontSize="12px" color="#808080">
                Excel File Here
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Box>

      <FormHelperText sx={{ color: theme.palette.error.main }}>
        {message}
      </FormHelperText>
    </Stack>
  );
};

FileDropzoneComponent.propTypes = {
  handleDropzone: PropsTypes.func.isRequired,
  fileName: PropsTypes.string,
  width: PropsTypes.oneOfType([PropsTypes.number, PropsTypes.string]),
  height: PropsTypes.oneOfType([PropsTypes.number, PropsTypes.string]),
};
